<script>
  import Select from 'svelte-select';

  export let items = [];
  export let filterText;
  export let value = null;
  export let listOpen = false;
</script>

<span class="styled">
  <Select
    {...$$restProps}
    placeholderAlwaysShow
    on:blur
    on:change
    on:clear
    on:error
    on:filter
    on:focus
    on:input
    on:loaded
    on:remove
    bind:listOpen
    bind:value
    bind:items
    bind:filterText
  >
    <slot name="list" slot="list" let:filteredItems {filteredItems} />
  </Select>
</span>

<style lang="scss" src="../select/select.scss"></style>
